import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/.umi-production/LocaleWrapper.jsx';
import _dvaDynamic from 'dva/dynamic';

const Router = require('dva/router').routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__index" */ '../../layouts/index.js'),
        })
      : require('../../layouts/index.js').default,
    routes: [
      {
        path: '/404',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404.js'),
            })
          : require('../404.js').default,
      },
      {
        path: '/about-setting',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__about-setting__index" */ '../about-setting/index.js'),
            })
          : require('../about-setting/index.js').default,
      },
      {
        path: '/about-us',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__about-us__index" */ '../about-us/index.tsx'),
            })
          : require('../about-us/index.tsx').default,
      },
      {
        path: '/alarm-notify',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__alarm-notify__index" */ '../alarm-notify/index.js'),
            })
          : require('../alarm-notify/index.js').default,
      },
      {
        path: '/alarm-setting',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__alarm-setting__index" */ '../alarm-setting/index.js'),
            })
          : require('../alarm-setting/index.js').default,
      },
      {
        path: '/book',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__book__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/book/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__book__index" */ '../book/index.js'),
            })
          : require('../book/index.js').default,
        Routes: [require('../../routes/private.js').default],
      },
      {
        path: '/book-overview/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__book-overview__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/book-overview/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__book-overview__hooks" */ '../book-overview/hooks.js'),
            })
          : require('../book-overview/hooks.js').default,
      },
      {
        path: '/book-overview',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__book-overview__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/book-overview/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__book-overview__index" */ '../book-overview/index.js'),
            })
          : require('../book-overview/index.js').default,
      },
      {
        path: '/book-overview/utils',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__book-overview__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/book-overview/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__book-overview__utils__index" */ '../book-overview/utils/index.js'),
            })
          : require('../book-overview/utils/index.js').default,
      },
      {
        path: '/book-statistics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__book-statistics__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/book-statistics/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__book-statistics__index" */ '../book-statistics/index.tsx'),
            })
          : require('../book-statistics/index.tsx').default,
      },
      {
        path: '/book-statistics/utils',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__book-statistics__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/book-statistics/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__book-statistics__utils__index" */ '../book-statistics/utils/index.ts'),
            })
          : require('../book-statistics/utils/index.ts').default,
      },
      {
        path: '/bookingForm',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__bookingForm__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/bookingForm/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bookingForm__index" */ '../bookingForm/index.js'),
            })
          : require('../bookingForm/index.js').default,
      },
      {
        path: '/bookingForm/util',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__bookingForm__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/bookingForm/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bookingForm__util__index" */ '../bookingForm/util/index.js'),
            })
          : require('../bookingForm/util/index.js').default,
      },
      {
        path: '/changePassword',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__changePassword__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/changePassword/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__changePassword__index" */ '../changePassword/index.js'),
            })
          : require('../changePassword/index.js').default,
      },
      {
        path: '/company-setting/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__company-setting__hooks__index" */ '../company-setting/hooks/index.ts'),
            })
          : require('../company-setting/hooks/index.ts').default,
      },
      {
        path: '/company-setting',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__company-setting__index" */ '../company-setting/index.tsx'),
            })
          : require('../company-setting/index.tsx').default,
      },
      {
        path: '/company-setting/service',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__company-setting__service__index" */ '../company-setting/service/index.ts'),
            })
          : require('../company-setting/service/index.ts').default,
      },
      {
        path: '/create/inventory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__create__inventory__index" */ '../create/inventory/index.js'),
            })
          : require('../create/inventory/index.js').default,
      },
      {
        path: '/custom-password',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__custom-password__index" */ '../custom-password/index.js'),
            })
          : require('../custom-password/index.js').default,
      },
      {
        path: '/customizetags',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__customizetags__models__customizetags.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/customizetags/models/customizetags.js').then(
                  m => {
                    return { namespace: 'customizetags', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__customizetags__index" */ '../customizetags/index.js'),
            })
          : require('../customizetags/index.js').default,
      },
      {
        path: '/department-apply',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__department-apply__index" */ '../department-apply/index.js'),
            })
          : require('../department-apply/index.js').default,
      },
      {
        path: '/department-approve',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__department-approve__index" */ '../department-approve/index.js'),
            })
          : require('../department-approve/index.js').default,
      },
      {
        path: '/desk-repair/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__desk-repair__hooks" */ '../desk-repair/hooks.js'),
            })
          : require('../desk-repair/hooks.js').default,
      },
      {
        path: '/desk-repair',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__desk-repair__index" */ '../desk-repair/index.js'),
            })
          : require('../desk-repair/index.js').default,
      },
      {
        path: '/desk-report',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__desk-report__index" */ '../desk-report/index.js'),
            })
          : require('../desk-report/index.js').default,
      },
      {
        path: '/deskrule',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__deskrule__models__autoRelease.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/deskrule/models/autoRelease.js').then(
                  m => {
                    return { namespace: 'autoRelease', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__deskrule__models__bookRule.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/deskrule/models/bookRule.js').then(
                  m => {
                    return { namespace: 'bookRule', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__deskrule__models__system.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/deskrule/models/system.js').then(
                  m => {
                    return { namespace: 'system', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__deskrule__index" */ '../deskrule/index.js'),
            })
          : require('../deskrule/index.js').default,
      },
      {
        path: '/detail/inventory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__detail__inventory__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/detail/inventory/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__detail__inventory__index" */ '../detail/inventory/index.js'),
            })
          : require('../detail/inventory/index.js').default,
      },
      {
        path: '/detail/relocation/dataHooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__detail__relocation__dataHooks" */ '../detail/relocation/dataHooks.js'),
            })
          : require('../detail/relocation/dataHooks.js').default,
      },
      {
        path: '/detail/relocation',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__detail__relocation__index" */ '../detail/relocation/index.js'),
            })
          : require('../detail/relocation/index.js').default,
      },
      {
        path: '/detail/relocation/util',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__detail__relocation__util" */ '../detail/relocation/util.js'),
            })
          : require('../detail/relocation/util.js').default,
      },
      {
        path: '/email-setting',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__email-setting__index" */ '../email-setting/index.js'),
            })
          : require('../email-setting/index.js').default,
      },
      {
        path: '/global-config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__global-config__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/global-config/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__global-config__index" */ '../global-config/index.js'),
            })
          : require('../global-config/index.js').default,
      },
      {
        path: '/global-config/util',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__global-config__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/global-config/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__global-config__util" */ '../global-config/util.js'),
            })
          : require('../global-config/util.js').default,
      },
      {
        path: '/iframe',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__iframe__index" */ '../iframe/index.js'),
            })
          : require('../iframe/index.js').default,
      },
      {
        path: '/',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__index" */ '../index.js'),
            })
          : require('../index.js').default,
      },
      {
        path: '/interfaceManage/building',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__interfaceManage__models__interfaceManage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/interfaceManage/models/interfaceManage.js').then(
                  m => {
                    return { namespace: 'interfaceManage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__interfaceManage__building__index" */ '../interfaceManage/building/index.js'),
            })
          : require('../interfaceManage/building/index.js').default,
      },
      {
        path: '/interfaceManage/floor',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__interfaceManage__models__interfaceManage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/interfaceManage/models/interfaceManage.js').then(
                  m => {
                    return { namespace: 'interfaceManage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__interfaceManage__floor__index" */ '../interfaceManage/floor/index.js'),
            })
          : require('../interfaceManage/floor/index.js').default,
      },
      {
        path: '/interfaceManage',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__interfaceManage__models__interfaceManage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/interfaceManage/models/interfaceManage.js').then(
                  m => {
                    return { namespace: 'interfaceManage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__interfaceManage__index" */ '../interfaceManage/index.js'),
            })
          : require('../interfaceManage/index.js').default,
      },
      {
        path: '/interfaceMap',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__interfaceMap__models__map.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/interfaceMap/models/map.js').then(
                  m => {
                    return { namespace: 'map', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__interfaceMap__index" */ '../interfaceMap/index.js'),
            })
          : require('../interfaceMap/index.js').default,
      },
      {
        path: '/inventory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__inventory__index" */ '../inventory/index.js'),
            })
          : require('../inventory/index.js').default,
      },
      {
        path: '/license/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__license__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/license/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__license__hooks" */ '../license/hooks.ts'),
            })
          : require('../license/hooks.ts').default,
      },
      {
        path: '/license',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__license__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/license/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__license__index" */ '../license/index.tsx'),
            })
          : require('../license/index.tsx').default,
      },
      {
        path: '/location',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__location__index" */ '../location/index.js'),
            })
          : require('../location/index.js').default,
      },
      {
        path: '/log',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__log__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/log/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__log__index" */ '../log/index.js'),
            })
          : require('../log/index.js').default,
      },
      {
        path: '/login',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__login__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/login/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__login__index" */ '../login/index.js'),
            })
          : require('../login/index.js').default,
      },
      {
        path: '/map',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__map__models__map.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/map/models/map.js').then(
                  m => {
                    return { namespace: 'map', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__map__index" */ '../map/index.js'),
            })
          : require('../map/index.js').default,
      },
      {
        path: '/map/util',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__map__models__map.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/map/models/map.js').then(
                  m => {
                    return { namespace: 'map', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__map__util" */ '../map/util.js'),
            })
          : require('../map/util.js').default,
      },
      {
        path: '/my-inventory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__my-inventory__index" */ '../my-inventory/index.js'),
            })
          : require('../my-inventory/index.js').default,
      },
      {
        path: '/myBooking',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__myBooking__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/myBooking/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__myBooking__index" */ '../myBooking/index.tsx'),
            })
          : require('../myBooking/index.tsx').default,
        Routes: [require('../../routes/private.js').default],
      },
      {
        path: '/myBooking/services',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__myBooking__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/myBooking/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__myBooking__services" */ '../myBooking/services.js'),
            })
          : require('../myBooking/services.js').default,
      },
      {
        path: '/notice-setting',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__notice-setting__index" */ '../notice-setting/index.js'),
            })
          : require('../notice-setting/index.js').default,
      },
      {
        path: '/organizationalStructure',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__organizationalStructure__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/organizationalStructure/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__organizationalStructure__index" */ '../organizationalStructure/index.js'),
            })
          : require('../organizationalStructure/index.js').default,
      },
      {
        path: '/personal-page',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__personal-page__model.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/personal-page/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__personal-page__index" */ '../personal-page/index.js'),
            })
          : require('../personal-page/index.js').default,
        title: 'MODIFY_PASSWORD',
      },
      {
        path: '/pre-employee/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__pre-employee__hooks" */ '../pre-employee/hooks.js'),
            })
          : require('../pre-employee/hooks.js').default,
      },
      {
        path: '/pre-employee',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__pre-employee__index" */ '../pre-employee/index.js'),
            })
          : require('../pre-employee/index.js').default,
      },
      {
        path: '/preference-setting',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__preference-setting__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/preference-setting/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__preference-setting__index" */ '../preference-setting/index.js'),
            })
          : require('../preference-setting/index.js').default,
      },
      {
        path: '/preference-setting/service',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__preference-setting__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/preference-setting/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__preference-setting__service__index" */ '../preference-setting/service/index.js'),
            })
          : require('../preference-setting/service/index.js').default,
      },
      {
        path: '/qr-code',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__qr-code__index" */ '../qr-code/index.tsx'),
            })
          : require('../qr-code/index.tsx').default,
      },
      {
        path: '/qr-code/service',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__qr-code__service__index" */ '../qr-code/service/index.ts'),
            })
          : require('../qr-code/service/index.ts').default,
      },
      {
        path: '/relocation-draft',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__relocation-draft__index" */ '../relocation-draft/index.js'),
            })
          : require('../relocation-draft/index.js').default,
      },
      {
        path: '/relocation-plan',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__relocation-plan__index" */ '../relocation-plan/index.js'),
            })
          : require('../relocation-plan/index.js').default,
      },
      {
        path: '/rolePermissions',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__rolePermissions__models__index.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/rolePermissions/models/index.js').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__rolePermissions__index" */ '../rolePermissions/index.js'),
            })
          : require('../rolePermissions/index.js').default,
      },
      {
        path: '/server_config/AddModal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__server_config__AddModal__index" */ '../server_config/AddModal/index.js'),
            })
          : require('../server_config/AddModal/index.js').default,
      },
      {
        path: '/server_config',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__server_config__index" */ '../server_config/index.js'),
            })
          : require('../server_config/index.js').default,
      },
      {
        path: '/server_config/request',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__server_config__request" */ '../server_config/request.js'),
            })
          : require('../server_config/request.js').default,
      },
      {
        path: '/space-types',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__space-types__index" */ '../space-types/index.js'),
            })
          : require('../space-types/index.js').default,
      },
      {
        path: '/spaceManage/building',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__spaceManage__models__manage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/spaceManage/models/manage.js').then(
                  m => {
                    return { namespace: 'manage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__spaceManage__building__index" */ '../spaceManage/building/index.js'),
            })
          : require('../spaceManage/building/index.js').default,
      },
      {
        path: '/spaceManage/floor',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__spaceManage__models__manage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/spaceManage/models/manage.js').then(
                  m => {
                    return { namespace: 'manage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__spaceManage__floor__index" */ '../spaceManage/floor/index.js'),
            })
          : require('../spaceManage/floor/index.js').default,
      },
      {
        path: '/spaceManage/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__spaceManage__models__manage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/spaceManage/models/manage.js').then(
                  m => {
                    return { namespace: 'manage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__spaceManage__hooks" */ '../spaceManage/hooks.ts'),
            })
          : require('../spaceManage/hooks.ts').default,
      },
      {
        path: '/spaceManage',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__spaceManage__models__manage.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/spaceManage/models/manage.js').then(
                  m => {
                    return { namespace: 'manage', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__spaceManage__index" */ '../spaceManage/index.js'),
            })
          : require('../spaceManage/index.js').default,
      },
      {
        path: '/sso-callback',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__sso-callback__index" */ '../sso-callback/index.js'),
            })
          : require('../sso-callback/index.js').default,
      },
      {
        path: '/sso-callback/util',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__sso-callback__util" */ '../sso-callback/util.js'),
            })
          : require('../sso-callback/util.js').default,
      },
      {
        path: '/statistics/hooks',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__statistics__models__statistics.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/statistics/models/statistics.js').then(
                  m => {
                    return { namespace: 'statistics', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__statistics__hooks__index" */ '../statistics/hooks/index.js'),
            })
          : require('../statistics/hooks/index.js').default,
      },
      {
        path: '/statistics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__statistics__models__statistics.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/statistics/models/statistics.js').then(
                  m => {
                    return { namespace: 'statistics', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__statistics__index" */ '../statistics/index.js'),
            })
          : require('../statistics/index.js').default,
      },
      {
        path: '/statistics/utils',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__statistics__models__statistics.js' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/statistics/models/statistics.js').then(
                  m => {
                    return { namespace: 'statistics', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__statistics__utils__index" */ '../statistics/utils/index.js'),
            })
          : require('../statistics/utils/index.js').default,
      },
      {
        path: '/third-part',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__third-part__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/third-part/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__third-part__index" */ '../third-part/index.tsx'),
            })
          : require('../third-part/index.tsx').default,
      },
      {
        path: '/user-approve',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user-approve__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/user-approve/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user-approve__index" */ '../user-approve/index.tsx'),
            })
          : require('../user-approve/index.tsx').default,
      },
      {
        path: '/user-page',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__user-page__models__index.ts' */ '/Users/admin/home/workRoot/kpmg_desking/d-desking-fe_kpmg/src/pages/user-page/models/index.ts').then(
                  m => {
                    return { namespace: 'index', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user-page__index" */ '../user-page/index.tsx'),
            })
          : require('../user-page/index.tsx').default,
      },
      {
        path: '/working-group',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__working-group__index" */ '../working-group/index.js'),
            })
          : require('../working-group/index.js').default,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404.js'),
            })
          : require('../404.js').default,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
